import type { FC } from '../../lib/teact/teact';
import React, { useEffect } from '../../lib/teact/teact';

import { Bundles } from '../../util/moduleLoader';
import { markStartupPerf } from '../../util/startupPerf';

import useModuleLoader from '../../hooks/useModuleLoader';

const AuthAsync: FC = () => {
  const Auth = useModuleLoader(Bundles.Auth, 'Auth');

  useEffect(() => {
    markStartupPerf(Auth ? 'auth_async_ready' : 'auth_async_waiting');
  }, [Auth]);

  return Auth ? <Auth /> : undefined;
};

export default AuthAsync;
